export default "__VITE_ASSET__Q76pwioD__"